export default __webpack_public_path__ + "static/media/enterprise-erp.b407a755.svg";